import React, { useEffect, useState } from 'react';
import { Col, Label, Row } from 'reactstrap';
import api from "../../../../services/api";
import _ from 'lodash';
import { useMsal } from '@azure/msal-react';
import ECCApprovalDetail from './ECCApprovalDetail';
import CandidateSelector from '../CandidateSelector';
import ECCBaseForm from './ECCBaseForm';
import ECCApprovalPanel from './ECCApprovalPanel';
import { checkApprover, getDefaultSelectedAllocation } from './ECCUtils';

const apiUrl = "employeechangeconditionv2";

export default function ECCForm(props) {
    const {
        isApproval,
        approvalData,
        itemInEdit,
        setItemInEdit,
        documents,
        setDocuments,
        setValidationObj,
        validationObj,
        setLoading,
        loading,
        footer,
    } = props;

    const [lookups, setLookups] = useState({});
    const [refreshItemInEditForHistory, setRefreshItemInEditForHistory] = useState(false);
    const [selectedAllocationHistoryRows, setSelectedAllocationHistoryRows] = useState([]);
    const [initialApprover, setInitialApprover] = useState(null);
    const [isApproverExists, setIsApproverExists] = useState(false);
    const [shouldCheckApprover, setShouldCheckApprover] = useState(false);
    const { instance } = useMsal();
    const user = instance.getActiveAccount();

    useEffect(() => {
        if (!shouldCheckApprover)
            return;

        setShouldCheckApprover(false);
        checkApprover(itemInEdit, setItemInEdit, setInitialApprover, setIsApproverExists, validationObj, setValidationObj, user, api, apiUrl, setLoading, _);
    }, [shouldCheckApprover]);

    useEffect(() => {
        setValidationObj([]);
    }, [itemInEdit?.categoryId]);

    useEffect(() => {
        if (!refreshItemInEditForHistory)
            return;

        setRefreshItemInEditForHistory(false);
        setItemInEdit({
            ...itemInEdit,
            projectId: selectedAllocationHistoryRows[0]?.original?.projectId ?? null,
            project: selectedAllocationHistoryRows[0]?.original?.project ?? null,
            positionId: selectedAllocationHistoryRows[0]?.original?.positionId ?? null,
            position: selectedAllocationHistoryRows[0]?.original?.position ?? null,
            currentEndDate: selectedAllocationHistoryRows[0]?.original?.endDate ?? null,
            proposedEndDate: selectedAllocationHistoryRows[0]?.original?.endDate ? itemInEdit.proposedEndDate : null,
        });
        setShouldCheckApprover(true);
    }, [refreshItemInEditForHistory]);

    return (
        <>
            <Row className="m-0 p-0">
                <Col xs={10}>
                {
                    (isApproval || (itemInEdit?.status?.lookupValue !== "Draft" && itemInEdit?.status?.lookupValue !== "Ready")) && itemInEdit?.employeeChangeConditionId ?
                    <Row className="m-0 p-0 p-2 mb-1 border-3 border-secondary w-100">
                        <Label><b>Approval History</b></Label>
                        <ECCApprovalDetail
                            id={itemInEdit.employeeChangeConditionId}
                        />
                    </Row>
                    :
                    null
                }
                    <CandidateSelector
                        setLoading={setLoading}
                        data={itemInEdit}
                        apiUrl={`${apiUrl}/employee/current`}
                        getDefaultSelectedAllocation={(rows) => getDefaultSelectedAllocation(itemInEdit, rows)}
                        onCandidateChanged={({candidateId, candidate, employmentType}) => {
                            setItemInEdit({
                                ...itemInEdit,
                                candidateId: candidateId,
                                candidate: candidate,
                                currentEmploymentType: employmentType,
                                currentEmploymentTypeId: employmentType?.employmentTypeId,
                                currentEmploymentTypeName: employmentType?.employmentTypeName,
                            });
                        }}
                        onSelectedAllocationHistoryChanged={(selectedRows) => {
                            setSelectedAllocationHistoryRows(selectedRows);
                            setRefreshItemInEditForHistory(true);
                        }}
                        disabled={isApproval || itemInEdit.statusName === "Approved"}
                    />
                    <ECCBaseForm
                        isApproval={isApproval}
                        approvalData={approvalData}
                        lookups={lookups}
                        setLookups={setLookups}
                        itemInEdit={itemInEdit}
                        setItemInEdit={setItemInEdit}
                        documents={documents}
                        setDocuments={setDocuments}
                        validationObj={validationObj}
                        setLoading={setLoading}
                        setShouldCheckApprover={setShouldCheckApprover}
                        selectedAllocationHistoryRows={selectedAllocationHistoryRows}
                        footer={footer}
                    />
                </Col>
                <Col xs={2} className="bg-secondary lrfstatusbox" style={{minHeight: "30vh"}}>
                    <ECCApprovalPanel
                        itemInEdit={itemInEdit}
                        loading={loading}
                        initialApprover={initialApprover}
                        isApproverExists={isApproverExists}
                    />
                </Col>
            </Row>
        </>
    );
};